enum RichMessageTemplate {
  Cards = 'cards',
  QuickReplies = 'quick_replies',
}

export default RichMessageTemplate;
